<template>
  <v-container>
    <v-row>
      <v-col cols="8">
        <v-text-field
          clearable
          :value="notification"
          input="newMessage"
          label="Notification"
          append-outer-icon="mdi-content-save"
          @change="saveText($event)"
          @click:clear="saveText('')">
        </v-text-field>
      </v-col>
      <v-col right>
        <v-btn-toggle>
          <v-btn
            small
            color="primary"
            @click="$router.push('/admin/visuals')">
            Visuals
          </v-btn>
          <v-btn
            small
            color="primary"
            @click="$router.push('/admin/hour')">
            Hours
          </v-btn>
          <v-btn
            small
            color="primary"
            @click="$router.push('/admin/menu-links')">
            Menu Links
          </v-btn>
        </v-btn-toggle>
      </v-col>
    </v-row>
    <v-row>
      <v-slider
        label="Room Volume"
        v-if = "roomVolume >= 0"
        v-model="roomVolume"
        append-icon="mdi-volume-high"
        :max=100
        :min=0
        thumb-label
      ></v-slider>
      <v-col md="2" xs="4">
        <v-text-field :value="lowVolume" @change="setNewLowVolume($event)" label="Low Volume" outlined></v-text-field>
      </v-col>
      <v-col md="2" xs="4">
        <v-text-field :value="highVolume" @change="setNewHighVolume($event)" label="High Volume" outlined></v-text-field>
      </v-col>
    </v-row>
    <v-card>
      <v-card-title>
        Users
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          append-icon="mdi-search"
          label="Search"
          single-line
          hide-details
        ></v-text-field>
      </v-card-title>
      <v-data-table :headers="headers" :items="users" :items-per-page="25" :search="search" sort-by="username">
        <template v-slot:item="user">
            <tr>
              <td>
                  <v-btn
                    v-if="user.item.admin !== true"
                    small v-bind:color="user.item.approved === true ? 'normal' : 'error'"
                    @click="toggleApproval(user.item)">
                      <v-icon>
                        {{user.item.approved === true ? 'mdi-account-check' : 'mdi-account-cancel'}}
                      </v-icon>
                  </v-btn>
                  <v-btn small disabled v-if="user.item.admin === true"><v-icon>mdi-shield-account</v-icon></v-btn>
              </td>
              <td>{{user.item.username}}</td>
              <td>{{user.item.name}}</td>
              <td>{{user.item.phoneNumber}}</td>
              <td>{{user.item.email}}</td>
              <td>{{user.item.connection}}</td>
              <td>
                <v-btn
                  v-if="!user.item.admin"
                  small v-bind:color="user.item.ignore ? 'primary' : ''"
                  @click="toggleIgnore(user.item)">
                  <v-icon>{{user.item.ignore ? 'mdi-account-remove-outline' : 'mdi-account-question-outline'}}</v-icon>
                </v-btn>
                <v-btn small disabled v-if="user.item.admin"><v-icon>mdi-shield-account</v-icon></v-btn>
              </td>
              <td>
                <v-btn
                  small v-bind:color="user.item.volumeControl ? 'primary' : ''"
                  @click="toggleVolumeControl(user.item)">
                  <v-icon>{{user.item.volumeControl ? 'mdi-volume-source ' : 'mdi-volume-variant-off'}}</v-icon>
                </v-btn>
              </td>
            </tr>
        </template>
      </v-data-table>
    </v-card>
  </v-container>
</template>
<script>
export default {
  data () {
    return {
      search: '',
      headers: [
        { text: 'Approved' },
        { text: 'Username', value: 'username' },
        { text: 'Name', value: 'realName' },
        { text: 'Phone' },
        { text: 'Email', value: 'email' },
        { text: 'Connection' },
        { text: 'Ignore' },
        { text: 'Volume Control' },
      ],
    }
  },
  computed: {
    users: function () {
      return this.$store.getters['users/getAll']()
    },
    notification: function () {
      return this.$store.getters['notification/getText']()
    },
    roomVolume: {
      set: function (value) {
        this.$store.dispatch('audioRecorder/setRoomVolume', {
          roomVolumePercent: value,
        })
      },
      get: function () {
        return this.$store.getters['audioRecorder/getRoomVolume']()
      },
    },
    lowVolume: function () {
      return this.$store.getters['audioRecorder/getLowVolume']()
    },
    highVolume: function () {
      return this.$store.getters['audioRecorder/getHighVolume']()
    },
  },
  mounted: function () {
    this.$store.dispatch('users/bindUsers')
    this.$store.dispatch('notification/bindNotification')
    this.$store.dispatch('audioRecorder/bindAudioRecorder')
  },
  methods: {
    saveText: function (newText) {
      this.$store.dispatch('notification/setText', { text: newText })
    },
    toggleApproval: function (user) {
      let userKey = this.$store.getters['users/getUserKeyByEmail'](user.email)
      this.$store.dispatch('users/toggleApproved', {
        userKey: userKey,
        approved: !user.approved,
      })
    },
    toggleIgnore: function (user) {
      let userKey = this.$store.getters['users/getUserKeyByEmail'](user.email)
      this.$store.dispatch('users/toggleIgnore', {
        userKey: userKey,
        ignore: !user.ignore,
      })
    },
    toggleVolumeControl: function (user) {
      let userKey = this.$store.getters['users/getUserKeyByEmail'](user.email)
      this.$store.dispatch('users/toggleVolumeControl', {
        userKey: userKey,
        volumeControl: !user.volumeControl,
      })
    },
    setNewHighVolume: function (value) {
      this.$store.dispatch('audioRecorder/setNewHighVolume', {
        highVolume: parseInt(value),
      })
    },
    setNewLowVolume: function (value) {
      this.$store.dispatch('audioRecorder/setNewLowVolume', {
        lowVolume: parseInt(value),
      })
    },
  },
}
</script>

<style scoped>
  >>>.v-input__append-outer .v-icon {
    color: darkcyan;
  }
</style>
